<template>

    <div class="feature-list">
        <swiper
            class="relative feature-match-swiper"
            :pagination="{ clickable: true }"
            :autoplay="{ delay: 5000, disableOnInteraction: false }">
            <!-- <div class="home-banner__layer"></div> -->
            <swiper-slide
                v-for="(o, index) in featuredMatchList"
                :key="index">
                <div class="feature-box">

                    <div v-if="o.matchState <= 0"
                        class="feature-match-time-box">
                        <div class="feature-match-time">
                            {{ o.formattedMatchDate }}
                        </div>
                    </div>
                    <!-- target="_blank" -->
                    <router-link
                        :to="{
                        path: `/${currentLocale}/${currentSportType}/${o.countryKey}/${
                            o.leagueKey
                        }/${
                            o.homeTeamName.replace(/(\s|\/)/g, '-') +
                            '-vs-' +
                            o.awayTeamName.replace(/(\s|\/)/g, '-')
                        }/${o.matchId}`,
                        }"
                        class="feature-item"
                        tag="div">
                        <div class="feature-child feature-team">
                            <Icon
                                :logoUrl="o.homeLogo"
                                class="feature-child-icon"
                            ></Icon>
                            <div class="feature-text">{{ o.homeTeamName }}</div>
                        </div>
                        <div class="feature-child feature-data">
                            <div class="feature-is-live" v-if="o.liveStreamUrl">
                                {{ $t('LIVE') }}
                            </div>
                            <!-- pending start -->
                            <div class="feature-score" v-if="o.matchState === 0">
                                {{ o.matchStatus }}
                            </div>
                            <!-- starting or ended -->
                            <div class="feature-score" v-else>
                                {{ o.matchStatus === 'AET' ? o.homeTeamExtraTimeScore : o.homeTeamScore ? o.homeTeamScore : '0' }}
                                <span>-</span>
                                {{ o.matchStatus === 'AET' ? o.awayTeamExtraTimeScore : o.awayTeamScore ? o.awayTeamScore : '0' }}
                            </div>
                            <div class="feature-status">
                                <div v-if="o.matchState < 0">
                                    {{ o.matchStatus }}
                                </div>
                                <FeatureMatchCountDown :o="o" v-else :featureMatchTimer="featureMatchTimer"  />
                            </div>
                        </div>
                        <div class="feature-child feature-team">
                            <Icon
                                :logoUrl="o.awayLogo"
                                class="feature-child-icon"
                            ></Icon>
                            <div  class="feature-text">{{ o.awayTeamName }}</div>
                        </div>
                    </router-link>
                </div>
            </swiper-slide>
        </swiper>

        <!-- <div
            class="feature-box" 
            v-for="(o,index) in featuredMatchList" 
            :key="index">
            <div v-if="o.matchState <= 0"
                class="feature-match-time-box">
                <div class="feature-match-time">
                     {{ o.formattedMatchDate }}
                </div>
            </div>
            <router-link
                :to="{
                path: `/${currentLocale}/${currentSportType}/${o.countryKey}/${
                    o.leagueKey
                }/${
                    o.homeTeamName.replace(/(\s|\/)/g, '-') +
                    '-vs-' +
                    o.awayTeamName.replace(/(\s|\/)/g, '-')
                }/${o.matchId}`,
                }"
                target="_blank"
                class="feature-item"
                tag="div">
                <div class="feature-child feature-team">
                    <Icon
                        :logoUrl="o.homeLogo"
                        class="feature-child-icon"
                    ></Icon>
                    <div class="feature-text">{{ o.homeTeamName }}</div>
                </div>
                <div class="feature-child feature-data">
                    <div class="feature-is-live" v-if="o.liveStreamUrl">
                        {{ $t('LIVE') }}
                    </div>
                    <div class="feature-score" v-if="o.matchState === 0">
                        {{ o.matchStatus }}
                    </div>
                    <div class="feature-score" v-else>
                        {{ o.homeTeamScore ? o.homeTeamScore : '0' }}
                        <span>-</span>
                        {{ o.awayTeamScore ? o.awayTeamScore : '0' }}
                    </div>
                    <div class="feature-status">
                        <div v-if="o.matchState < 0">
                            {{ o.matchStatus }}
                        </div>
                        <FeatureMatchCountDown :o="o" v-else :featureMatchTimer="featureMatchTimer"  />
                    </div>
                </div>
                <div class="feature-child feature-team">
                    <Icon
                        :logoUrl="o.awayLogo"
                        class="feature-child-icon"
                    ></Icon>
                    <div  class="feature-text">{{ o.awayTeamName }}</div>
                </div>
            </router-link>
        </div> -->
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from "swiper/vue";
    import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper/core";
    SwiperCore.use([Pagination, Navigation, Autoplay]);
    import { mapGetters } from 'vuex';
    import FeatureMatchCountDown from './FeatureMatchCountDown.vue'
    export default {
        name: 'FeatureMatchListContent',
        props: {
            featuredMatchList: Array,
            featureMatchTimer: Object
        },
        computed: {
            ...mapGetters([
                'currentLocale',
                'currentSportType',
                'currentLanguageObj'
            ]),
        },
        components: {
            FeatureMatchCountDown,
            Swiper,
            SwiperSlide,
        },
        mounted() {
            
        },
        methods: {
            isMatchEnded(match) {
                return match.matchState < 0 ? true : false;
            },

        }
    }
</script>

<style scoped>
.feature-list {

}
.feature-box {
    padding: 16px 8px;
    background-color: var(--color-background-default-tertiary);
    border-radius: 8px;
    margin-bottom: 16px;
    cursor: pointer;

}
.feature-match-time-box {
    display: flex;
    align-items: center;
    justify-content: center;
}
.feature-match-time {
    background-color: var(--color-background-default-secondary-hover);
    color: var(--color-text-default-default);
    padding: 4px 10px;
    box-sizing: border-box;
    border-radius: 8px;
    margin-bottom: 8px;
    font-size: 12px;
    font-family: var(--weight-600);
	letter-spacing: 0.2px;
}
.feature-item {
    display: flex;
    align-items: center;
    justify-content: center;

}
.feature-item:last-child {
    margin-bottom: 0;
}
.feature-box:hover {
    background-color: var(--color-background-default-tertiary-hover);
}
.feature-box:hover .feature-match-time {
    background-color: var(--color-background-default-secondary);
}
.feature-child {
    width: 33%;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}
.feature-team {
    font-size: 14px;
    flex-direction: column;
    letter-spacing: .64px;
    color: var(--color-text-default-default);
}
.feature-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;

}
.feature-data {
    width: 80px;
    /* display: block; */
}
.feature-is-live {
    padding: 4px 12px;
    border-radius: 16px;
    background-color: var(--color-background-error-default);
    letter-spacing: .24px;
    font-size: 12px;
    text-transform: uppercase;
    font-family: var(--weight-700);
	letter-spacing: 0.2px;
}
.feature-score {
    font-size: 20px;
    font-family: var(--weight-600);
}
.feature-status {
    color: var(--color-text-primary-default);
    font-size: 12px;
    font-family: var(--weight-700);
	letter-spacing: 0.2px;
}
.feature-day {
    
    color: var(--color-text-default-secondary);
    font-size: 12px;
	letter-spacing: 0.2px;
}
.feature-child-icon {
    width: 56px;
    height: 56px;
    margin-bottom: 4px;

}
</style>

<style>
.feature-match-swiper {
    padding-bottom: 16px;
}
.swiper-pagination-bullets {
    bottom: 0px !important;
}
.swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    background-color: var(--color-background-brand-secondary);
}
.swiper-pagination-bullet-active {
    background-color: var(--color-background-brand-default);
    width: 24px;
}
</style>